import dayjs from 'dayjs'
import dayOfYear from 'dayjs/plugin/dayOfYear'

import { api } from '@api'
import { Filters, GetTicketsResponse, Ticket } from '@types'
import { ImplementationTimeUtils } from '@utils'

dayjs.extend(dayOfYear)

const { inImplementationZone, companyStartOfDay, companyEndOfDay, companyStartOfIsoWeek } =
  ImplementationTimeUtils

type Params = {
  filters?: Filters
  gmtZone?: number
}

const adjustFiltersForCompany = (filters?: Filters, gmtZone = 0): Filters | undefined => {
  if (!filters) return filters

  return {
    ...filters,
    ...(filters.mondayOfWeek
      ? { mondayOfWeek: companyStartOfIsoWeek(filters.mondayOfWeek, gmtZone).toDate() }
      : {}),
    ...(filters.dateFrom
      ? { dateFrom: companyStartOfDay(filters.dateFrom, gmtZone).toDate() }
      : {}),
    ...(filters.dateTo ? { dateTo: companyEndOfDay(filters.dateTo, gmtZone).toDate() } : {}),
    ...(filters.withdrawalDate
      ? { withdrawalDate: companyStartOfDay(filters.withdrawalDate, gmtZone).toDate() }
      : {}),
  }
}

const getTickets = async (params: Params) => {
  const { filters, gmtZone = 0 } = params
  const response = await api.get<GetTicketsResponse>('/tickets', {
    params: adjustFiltersForCompany(filters, gmtZone),
  })

  const ticketsAux = response.data.tickets?.tickets.map((ticket: Ticket) => {
    const withdrawalDay = inImplementationZone(ticket.withdrawalDate, gmtZone).format('DD-MM-YYYY')
    const withdrawalTime = inImplementationZone(ticket.withdrawalDate, gmtZone).format('HH:mm')
    const withdrawalDayOfYear = inImplementationZone(ticket.withdrawalDate, gmtZone).dayOfYear()
    return {
      ...ticket,
      withdrawalDay,
      withdrawalTime,
      withdrawalDayOfYear,
    }
  }) as Ticket[]
  const tickets = ticketsAux
    ? {
        tickets: ticketsAux,
        total: response.data.tickets?.total,
      }
    : response.data.tickets
  return tickets
}

export const TicketsApi = {
  getTickets,
}
